import React, { useState, useMemo, useEffect } from "react";
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro"; //eslint-disable-line
import { connect } from 'react-redux'
import Currency from "react-currency-formatter";

import Header from "components/Navbar.js";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import checkoutBanner from 'images/images/Multipurpose_Template_1920x1080px.jpeg'
import { ReactComponent as CheckboxIcon } from "images/checkbox-circle.svg";
import PaystackForm from 'components/pricing/CheckoutPaystack'
import { useHistory } from "react-router-dom";
import cogoToast from "cogo-toast";
import {
  removeFromBasket,
  clearBasket,
  removeBasketFeature,
  updateBasketFeatureQuantity
} from 'services/actions.js'

// ── SVG Icons ─────────────────────────────────────────────────────────────────
const TrashIcon = ({ className = "" }) => (
  <svg className={className} width="16" height="16" style={{ display: 'inline-block', width: '16px', height: '16px' }} fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path strokeLinecap="round" strokeLinejoin="round" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
  </svg>
);

const EditIcon = ({ className = "" }) => (
  <svg className={className} width="16" height="16" style={{ display: 'inline-block', width: '16px', height: '16px' }} fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path strokeLinecap="round" strokeLinejoin="round" d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
  </svg>
);

const CheckIcon = ({ className = "" }) => (
  <svg className={className} width="18" height="18" style={{ display: 'inline-block', width: '18px', height: '18px' }} fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
  </svg>
);

const CloseIcon = ({ className = "" }) => (
  <svg className={className} width="16" height="16" style={{ display: 'inline-block', width: '16px', height: '16px' }} fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
  </svg>
);

const PlusIcon = ({ className = "" }) => (
  <svg className={className} width="12" height="12" style={{ display: 'inline-block', width: '12px', height: '12px' }} fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path strokeLinecap="round" strokeLinejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
  </svg>
);

const MinusIcon = ({ className = "" }) => (
  <svg className={className} width="12" height="12" style={{ display: 'inline-block', width: '12px', height: '12px' }} fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 12h-15" />
  </svg>
);

const BasketIcon = ({ className = "text-teal-600" }) => (
  <svg className={className} width="24" height="24" style={{ display: 'inline-block', width: '24px', height: '24px' }} fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path strokeLinecap="round" strokeLinejoin="round" d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z" />
  </svg>
);

const InvoiceIcon = ({ className = "text-teal-600" }) => (
  <svg className={className} width="24" height="24" style={{ display: 'inline-block', width: '24px', height: '24px' }} fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path strokeLinecap="round" strokeLinejoin="round" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
  </svg>
);


// ── Layout ────────────────────────────────────────────────────────────────────
const Banner = styled.div(props => [
  `background-image: linear-gradient(to right, rgba(2,44,34,0.85), rgba(20,83,45,0.75)), url(${props.i});`,
  tw`relative -mx-8 bg-center bg-cover py-8`
]);
const BannerInner = tw.div`px-6 sm:px-8 max-w-screen-xl mx-auto py-16 md:py-20 text-center md:text-left`;
const BannerTitle = tw.h1`text-4xl sm:text-5xl font-extrabold text-white tracking-tight leading-tight`;
const BannerSub = tw.p`mt-3 text-lg text-teal-100 font-medium max-w-2xl`;

const Shell = tw.div`max-w-screen-xl mx-auto px-4 sm:px-8 -mt-12 pb-24 relative z-10`;
const Panel = styled.div`
  ${tw`bg-white rounded-3xl shadow-xl border border-gray-100 p-6 sm:p-8 transition-all duration-300`}
`;
const SectionTitle = tw.h2`text-xl font-bold text-gray-900 mb-6 flex items-center gap-3`;

// ── Cart line ──────────────────────────────────────────────────────────────────
const LineCard = styled.div`
  ${tw`relative rounded-2xl bg-white mb-5 overflow-hidden`}
  border: 1px solid #e5e7eb;
  box-shadow: 0 2px 8px rgba(0,0,0,0.05), 0 0 0 1px rgba(0,0,0,0.03);
  transition: box-shadow 0.25s ease, transform 0.25s ease;
  &:hover {
    box-shadow: 0 8px 24px rgba(0,0,0,0.09), 0 0 0 1px rgba(13,148,136,0.15);
    transform: translateY(-2px);
  }
`;

const LineHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 18px 20px;
  background: #ffffff;
  border-bottom: 1px solid #f3f4f6;
  border-left: 3px solid #0d9488;
  @media (min-width: 640px) {
    flex-direction: row;
    align-items: center;
  }
`;

const LineThumbWrap = styled.div`
  flex-shrink: 0;
  width: 72px;
  height: 72px;
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid #e5e7eb;
  background: linear-gradient(135deg, #f0fdf4 0%, #d1fae5 100%);
  box-shadow: inset 0 1px 4px rgba(0,0,0,0.05);
  display: flex;
  align-items: center;
  justify-content: center;
`;

const LineThumb = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const LineTitle = styled.h3`
  font-weight: 700;
  color: #111827;
  font-size: 1rem;
  line-height: 1.4;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  transition: color 0.15s;
  &:hover { color: #0d9488; }
  @media (min-width: 640px) { font-size: 1.0625rem; }
`;

const LineMeta = styled.p`
  margin-top: 5px;
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
`;

const LineBadge = styled.span`
  font-size: 0.7rem;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 999px;
  background: #f0fdf4;
  color: #065f46;
  border: 1px solid #a7f3d0;
  letter-spacing: 0.01em;
`;

const LineTotal = styled.div`
  margin-left: auto;
  flex-shrink: 0;
  font-size: 1.125rem;
  font-weight: 800;
  background: linear-gradient(135deg, #0d9488, #065f46);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  white-space: nowrap;
`;

const LineRemove = styled.button`
  flex-shrink: 0;
  padding: 8px;
  border-radius: 10px;
  color: #d1d5db;
  transition: all 0.2s;
  &:hover {
    color: #ef4444;
    background: #fef2f2;
  }
`;

// ── Feature rows ───────────────────────────────────────────────────────────────
const FeatureList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
`;

const FeatureRow = styled.li`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 12px 20px;
  border-bottom: 1px solid #f9fafb;
  transition: background 0.15s;
  &:nth-child(even) { background: #fafbfc; }
  &:nth-child(odd)  { background: #ffffff; }
  &:hover           { background: #f0fdf4; }
  &:last-child      { border-bottom: none; }
  @media (min-width: 640px) {
    flex-direction: row;
    align-items: center;
  }
`;

const FeatureDot = tw.span`w-5 h-5 text-teal-600 flex-shrink-0 hidden sm:block`;
const FeatureText = tw.span`flex-1 text-sm text-gray-700 leading-relaxed`;
const FeatureQty = tw.span`flex items-center gap-1 text-xs whitespace-normal self-end sm:self-auto`;

const IconBtn = styled.button`
  width: 30px;
  height: 30px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.18s;
  border: 1px solid transparent;
  ${({ danger }) => danger
    ? `color: #dc2626; background: #fef2f2;
       &:hover { background: #fee2e2; border-color: #fca5a5; }`
    : `color: #6b7280; background: #f3f4f6;
       &:hover { background: #ccfbf1; color: #0d9488; border-color: #5eead4; }`}
`;

// ── Inline quantity editor ─────────────────────────────────────────────────────
const QtyStepper = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 3px;
  border-radius: 10px;
  border: 1px solid #e5e7eb;
  background: #f9fafb;
`;

const QtyBtn = styled.button`
  width: 24px;
  height: 24px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  background: white;
  color: #374151;
  box-shadow: 0 1px 2px rgba(0,0,0,0.08);
  transition: all 0.18s;
  &:hover { background: #0d9488; color: white; }
  &:active { transform: scale(0.92); }
`;

const QtyVal = styled.span`
  text-align: center;
  font-weight: 700;
  color: #1f2937;
  font-size: 0.875rem;
  padding: 0 4px;
  min-width: 22px;
`;

// ── Price chip ─────────────────────────────────────────────────────────────────
const PriceChip = styled.span`
  font-size: 0.75rem;
  font-weight: 700;
  color: #065f46;
  background: #f0fdf4;
  border: 1px solid #a7f3d0;
  padding: 1px 9px;
  border-radius: 999px;
  white-space: nowrap;
`;

const UnitPrice = styled.span`
  font-size: 0.7rem;
  color: #9ca3af;
  white-space: nowrap;
`;

// ── Summary / discount ─────────────────────────────────────────────────────────
const SummaryPanel = styled.div`
  ${tw`lg:sticky`}
  top: 2rem;
`;
const SummaryRow = tw.div`flex justify-between items-center py-3 text-sm font-medium`;
const SummaryLabel = tw.span`text-gray-500`;
const SummaryValue = tw.span`text-gray-900 font-semibold`;
const Divider = tw.div`my-4 border-t border-gray-100`;

const DiscountRow = tw.div`flex gap-2 mt-2`;
const DiscountInput = styled.input`
  ${tw`flex-1 px-4 py-3 border border-gray-200 rounded-xl focus:outline-none focus:border-teal-900 transition-all text-sm`}
  ${({ invalid }) => invalid && tw`border-red-400 focus:border-red-400`}
`;
const DiscountBtn = tw.button`px-5 py-3 rounded-xl bg-teal-600 text-white font-semibold hover:bg-teal-700 hover:shadow-lg transition-all duration-200 active:scale-95 disabled:opacity-50 disabled:cursor-not-allowed text-sm`;
const DiscountNote = tw.p`text-xs mt-2 font-medium`;
const ClearCartLink = tw.button`inline-flex items-center justify-center gap-1 px-4 py-2 mx-2 rounded-xl border border-red-200 text-red-600 hover:bg-red-100 transition-all duration-200 text-sm font-semibold`;

// ── Empty state ────────────────────────────────────────────────────────────────
const EmptyState = tw.div`text-center py-20`;
const EmptyIcon = tw.div`text-6xl mb-4`;
const EmptyText = tw.p`text-gray-500 mb-6`;
const ShopBtn = tw.button`inline-flex items-center justify-center gap-1 px-5 py-2 rounded-xl bg-teal-600 hover:bg-teal-700 text-white font-semibold shadow-md hover:shadow-lg active:scale-95 transition-all duration-200 text-sm`;

// ── Discount config ────────────────────────────────────────────────────────────
// Admin-managed codes live in app_settings (key: "discount_codes",
// value: [{ code, rate }]). These are sensible built-ins as a fallback so the
// feature is usable out of the box, but the Firestore list wins when present.
const FALLBACK_DISCOUNT_CODES = [
  { code: "WELCOME10", rate: 0.10 },
  { code: "FOODNOMIX15", rate: 0.15 },
  { code: "FRESH5", rate: 0.05 },
];

const normalizeCode = (c) => (c || "").trim().toUpperCase();

function ShoppingCartComponent(props) {
  const history = useHistory();
  const [sortOrder, setSortOrder] = useState('asc');
  const [editingKey, setEditingKey] = useState(null); // `${item.id}::${feature.id}`
  const [editQty, setEditQty] = useState(1);

  const [discountInput, setDiscountInput] = useState("");
  const [appliedCode, setAppliedCode] = useState(null); // { code, rate }
  const [discountError, setDiscountError] = useState("");
  const [serverCodes, setServerCodes] = useState([]);

  const items = props.selectItems || [];
  const selectTotal = items.reduce((t, item) => t + Number(item.quantity || 0), 0);
  const selectSubTotal = items.reduce((t, item) => t + Number(item.total || 0), 0);

  const sortedItems = useMemo(
    () => [...items].sort((a, b) => sortOrder === 'asc' ? (a.total || 0) - (b.total || 0) : (b.total || 0) - (a.total || 0)),
    [items, sortOrder]
  );

  // Load admin-managed discount codes (optional).
  useEffect(() => {
    let active = true;
    const load = async () => {
      try {
        const { fetchAppSettings } = await import("DBServices/firestoreDBService");
        const settings = await fetchAppSettings();
        const entry = settings.find(s => s.key === 'discount_codes');
        const codes = Array.isArray(entry?.value) ? entry.value : [];
        if (active && codes.length) setServerCodes(codes);
      } catch (e) {
        /* offline / missing collection — fallbacks still apply */
      }
    };
    load();
    return () => { active = false; };
  }, []);

  const allCodes = serverCodes.length ? serverCodes : FALLBACK_DISCOUNT_CODES;

  const formatText = (text) => (text || "").replace(/_/g, ' ');

  const applyDiscount = () => {
    const code = normalizeCode(discountInput);
    if (!code) {
      setDiscountError("Enter a discount code.");
      return;
    }
    const match = allCodes.find(c => normalizeCode(c.code) === code);
    if (!match) {
      setDiscountError("That code isn't valid.");
      setAppliedCode(null);
      return;
    }
    setAppliedCode({ code: match.code, rate: Number(match.rate) || 0 });
    setDiscountError("");
    cogoToast.success(`Code "${match.code}" applied — ${(Number(match.rate) * 100).toFixed(0)}% off!`);
  };

  const removeDiscount = () => {
    setAppliedCode(null);
    setDiscountInput("");
    setDiscountError("");
  };

  const handleEditSave = (itemId, featureId) => {
    if (editQty >= 1) props.updateFeatureQty(itemId, featureId, editQty);
    setEditingKey(null);
  };

  const handlePaymentSuccess = () => {
    removeDiscount();
    props.clearBasket();
    setTimeout(() => history.push('/'), 2000);
  };

  if (!items.length) {
    return (
      <AnimationRevealPage>
        <Header />
        <Banner i={checkoutBanner}>
          <BannerInner>
            <BannerTitle>Shopping Basket</BannerTitle>
            <BannerSub>Your basket is empty — let's fix that.</BannerSub>
          </BannerInner>
        </Banner>
        <Shell>
          <Panel>
            <EmptyState>
              <EmptyIcon>🛒</EmptyIcon>
              <EmptyText>No foodstuffs in your basket yet.</EmptyText>
              <ShopBtn onClick={() => history.push('/')}>Browse the Market</ShopBtn>
            </EmptyState>
          </Panel>
        </Shell>
      </AnimationRevealPage>
    );
  }

  return (
    <AnimationRevealPage>
      <Header />
      <Banner i={checkoutBanner}>
        <BannerInner>
          <BannerTitle>Shopping Basket</BannerTitle>
          <BannerSub>{selectTotal} item{selectTotal === 1 ? '' : 's'} · ₦{selectSubTotal.toLocaleString()} subtotal</BannerSub>
        </BannerInner>
      </Banner>

      <Shell>
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {/* ── Cart lines ─────────────────────────────────────────── */}
          <div className="lg:col-span-2 mb-4">
            <Panel>
              <div className="flex items-center justify-between mb-6 pb-4 border-b border-gray-100 relative">
                <SectionTitle className="mb-0 flex items-center gap-2">
                  <BasketIcon />
                  <span>Your Items</span>
                </SectionTitle>
                <button
                  className="absolute right-2 top-1/2 -translate-y-1/2 inline-flex items-center p-2 rounded text-gray-500 hover:text-teal-700 hover:bg-teal-100 transition-all duration-200"
                  onClick={() => setSortOrder(p => p === 'asc' ? 'desc' : 'asc')}
                  title="Sort by price"
                >
                  {sortOrder === 'asc' ? (
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M3 4h13M3 8h9m-9 4h9m5-4v12m0 0l-3-3m3 3l3-3" />
                    </svg>
                  ) : (
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M3 4h13M3 8h9m-9 4h6m4 0l3-3m-3 3v12m0 0l-3-3m3 3l3-3" />
                    </svg>
                  )}
                </button>
              </div>

              {sortedItems.map((item) => (
                <LineCard key={item.id}>
                  {/* ── Item header ── */}
                  <LineHeader>
                    <LineThumbWrap>
                      {item.imageSrc
                        ? <LineThumb src={item.imageSrc} alt={item.title} />
                        : <BasketIcon style={{ width: 28, height: 28, color: '#5eead4' }} />}
                    </LineThumbWrap>

                    <div style={{ minWidth: 0, flex: 1 }}>
                      <LineTitle>{formatText(item.title)}</LineTitle>
                      <LineMeta>
                        <LineBadge>{item.basket?.length || 0} line{(item.basket?.length || 0) !== 1 ? 's' : ''}</LineBadge>
                        <span style={{ color: '#d1d5db', fontSize: '0.75rem' }}>·</span>
                        <LineBadge>{item.quantity} unit{item.quantity !== 1 ? 's' : ''}</LineBadge>
                      </LineMeta>
                    </div>

                    <LineTotal>
                      <Currency quantity={item.total} currency="NGN" />
                    </LineTotal>

                    <LineRemove
                      title="Remove item"
                      onClick={() => props.removeItemFromBasket(item)}
                    >
                      <TrashIcon />
                    </LineRemove>
                  </LineHeader>

                  {/* ── Feature rows ── */}
                  <FeatureList>
                    {item.basket?.map((feature) => {
                      const key = `${item.id}::${feature.id}`;
                      const isEditing = editingKey === key;
                      return (
                        <FeatureRow key={feature.id}>
                          <FeatureDot as={CheckboxIcon} />

                          <FeatureText>
                            {isEditing ? (
                              <span style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '10px' }}>
                                <span style={{ fontWeight: 600, color: '#1f2937', fontSize: '0.875rem' }}>
                                  {formatText(feature.type)} · {formatText(feature.measure)}
                                </span>
                                <QtyStepper>
                                  <QtyBtn type="button" onClick={() => setEditQty(q => Math.max(1, Number(q) - 1))}>
                                    <MinusIcon />
                                  </QtyBtn>
                                  <QtyVal>{editQty}</QtyVal>
                                  <QtyBtn type="button" onClick={() => setEditQty(q => Number(q) + 1)}>
                                    <PlusIcon />
                                  </QtyBtn>
                                </QtyStepper>
                                <PriceChip>@ ₦{feature.price} each</PriceChip>
                              </span>
                            ) : (
                              <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
                                <span style={{ fontWeight: 600, color: '#111827', fontSize: '0.875rem' }}>
                                  {formatText(feature.type)}
                                </span>
                                <span style={{ color: '#9ca3af', fontSize: '0.75rem' }}>
                                  {feature.quantity}× {formatText(feature.measure)}
                                </span>
                              </div>
                            )}
                          </FeatureText>

                          {/* Price & total (non-editing) */}
                          {!isEditing && (
                            <div style={{ display: 'flex', alignItems: 'center', gap: '6px', flexShrink: 0 }}>
                              <UnitPrice>@ ₦{feature.price}</UnitPrice>
                              <span style={{ color: '#d1d5db', fontSize: '0.75rem' }}>→</span>
                              <PriceChip>₦{feature.total}</PriceChip>
                            </div>
                          )}

                          {/* Action buttons */}
                          <FeatureQty>
                            {isEditing ? (
                              <>
                                <IconBtn title="Save" onClick={() => handleEditSave(item.id, feature.id)}>
                                  <CheckIcon />
                                </IconBtn>
                                <IconBtn title="Cancel" onClick={() => setEditingKey(null)}>
                                  <CloseIcon />
                                </IconBtn>
                              </>
                            ) : (
                              <>
                                <IconBtn title="Edit quantity" onClick={() => { setEditQty(feature.quantity); setEditingKey(key); }}>
                                  <EditIcon />
                                </IconBtn>
                                <IconBtn danger title="Remove line" onClick={() => props.removeFeature(item.id, feature.id)}>
                                  <TrashIcon />
                                </IconBtn>
                              </>
                            )}
                          </FeatureQty>
                        </FeatureRow>
                      );
                    })}
                  </FeatureList>
                </LineCard>
              ))}

              <div className="flex flex-col sm:flex-row justify-between items-stretch sm:items-center gap-12 mt-6 pt-4 border-t border-gray-100">
                <ClearCartLink onClick={() => { if (window.confirm('Remove all items from your basket?')) props.clearBasket(); }}>
                  <TrashIcon className="w-4 h-4" />
                  <span>Clear basket</span>
                </ClearCartLink>
                <ShopBtn onClick={() => history.push('/')}>
                  <svg width="16" height="16" style={{ width: '16px', height: '16px', display: 'inline-block' }} fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
                  </svg>
                  <span>Add more</span>
                </ShopBtn>
              </div>
            </Panel>
          </div>

          {/* ── Summary + discount + checkout ─────────────────────── */}
          <div className="lg:col-span-1">
            <SummaryPanel>
              <Panel className="mb-6">
                <SectionTitle className="flex items-center gap-2">
                  <InvoiceIcon />
                  <span>Summary</span>
                </SectionTitle>

                <SummaryRow>
                  <SummaryLabel>Subtotal ({selectTotal} items)</SummaryLabel>
                  <SummaryValue><Currency quantity={selectSubTotal} currency="NGN" /></SummaryValue>
                </SummaryRow>

                {appliedCode && (
                  <SummaryRow>
                    <SummaryLabel>Discount ({appliedCode.code}, {(appliedCode.rate * 100).toFixed(0)}%)</SummaryLabel>
                    <SummaryValue className="text-teal-600">
                      −<Currency quantity={selectSubTotal * appliedCode.rate} currency="NGN" />
                    </SummaryValue>
                  </SummaryRow>
                )}

                <Divider />

                <div className="flex flex-col gap-1">
                  <label className="text-xs font-bold text-gray-500 uppercase tracking-wider">Discount code</label>
                  <DiscountRow className="items-stretch">
                    <DiscountInput
                      value={discountInput}
                      invalid={!!discountError}
                      placeholder="e.g. WELCOME10"
                      onChange={(e) => { setDiscountInput(e.target.value); setDiscountError(""); }}
                      onKeyDown={(e) => { if (e.key === 'Enter') applyDiscount(); }}
                    />
                    <DiscountBtn onClick={applyDiscount}>Apply</DiscountBtn>
                  </DiscountRow>
                  {discountError
                    ? <DiscountNote className="text-red-900 flex items-center gap-1">
                        <CloseIcon className="w-4 h-4" />
                        {discountError}
                      </DiscountNote>
                    : appliedCode
                      ? <DiscountNote className="text-teal-600 flex items-center flex-wrap gap-1">
                          <span className="bg-teal-100 px-2 py-0 rounded border border-teal-100 font-bold">Code "{appliedCode.code}" active</span>
                          <button className="text-red-900 hover:text-red-600 underline font-semibold text-xs ml-1" onClick={removeDiscount}>Remove</button>
                        </DiscountNote>
                      : <DiscountNote className="text-gray-400">Have a promo code? Enter it above.</DiscountNote>}
                </div>

                <Divider />

                <PaystackForm
                  items={items}
                  discountRate={appliedCode ? appliedCode.rate : 0}
                  appliedCode={appliedCode ? appliedCode.code : ""}
                  onSuccess={handlePaymentSuccess}
                />
              </Panel>
            </SummaryPanel>
          </div>
        </div>
      </Shell>
    </AnimationRevealPage>
  );
}

const ShoppingCart = connect(
  (state) => ({ selectItems: state.TabCardGridData.items }),
  (dispatch) => ({
    removeItemFromBasket: (product) => dispatch(removeFromBasket(product)),
    clearBasket: () => dispatch(clearBasket()),
    removeFeature: (productId, featureId) => dispatch(removeBasketFeature(productId, featureId)),
    updateFeatureQty: (productId, featureId, quantity) => dispatch(updateBasketFeatureQuantity(productId, featureId, quantity)),
  })
)(ShoppingCartComponent);

export default ShoppingCart;
